import * as dateFns from 'date-fns';
import { Timestamp } from './firebase';

/**
 * Normalizes a date to a zoned time based on the specified timezone.
 * @param {Timestamp|Date} date - The date to normalize.
 * @returns {Date} The normalized date in the specified timezone.
 * @throws {Error} If the input date is not a valid Timestamp or Date object.
 */
export default function normalizeDate(_date, timeZone = 'UTC') {
  let date;

  if (_date instanceof Timestamp) {
    // Firestore Timestamp
    date = _date;
  } else if (_date instanceof Date) {
    // JS Date object
    date = _date;
  } else if (typeof _date === 'string') {
    // String
    date = dateFns.parseISO(_date);
  } else if (typeof _date === 'object') {
    // Object
    date = new Timestamp(_date._seconds, _date._nanoseconds);
  } else if (typeof _date === 'number') {
    // Number
    date = new Date(_date);
  } else {
    // Something else
    throw new Error('Invalid date type');
  }

  if (!(date instanceof Timestamp) && !(date instanceof Date)) throw new Error('Invalid date type');

  const jsDate = date instanceof Timestamp ? date.toDate() : date;
  const zonedDate = new Date(jsDate.toLocaleString('en-US', { timeZone }));
  return zonedDate;
}
